import { Button } from 'core-components/library/button'

import styles from './SelectPlaceholder.module.scss'

interface ISelectPlaceholder {
  onReloadClick: () => void
}

export const SelectPlaceholder = ({ onReloadClick }: ISelectPlaceholder) => {
  return (
    <div className={styles.root}>
      <span>Something went wrong. Try to reload the data</span>
      <Button className={styles.reloadButton} onClick={onReloadClick}>
        Reload
      </Button>
    </div>
  )
}
